module.exports = __webpack_public_path__ + "img/1514116916.311fa622.jpg";